import type {
  AttendanceRecord,
  AttendanceSummary,
  ClockInData,
  ClockInResponse,
  ClockOutData,
  ClockOutResponse,
  TodayAttendance,
} from '@/types';
import { buildQueryString } from '@/utils';
import api from './api';

export const attendanceService = {
  async clockIn(data: ClockInData): Promise<ClockInResponse> {
    const response = await api.post<ClockInResponse>('/attendance/clock-in', data);
    return response.data;
  },

  async clockOut(data: ClockOutData): Promise<ClockOutResponse> {
    const response = await api.post<ClockOutResponse>('/attendance/clock-out', data);
    return response.data;
  },

  async getTodayAttendance(): Promise<TodayAttendance> {
    const response = await api.get<TodayAttendance>('/attendance/today');
    return response.data;
  },

  async canClockIn(): Promise<{ canClockIn: boolean }> {
    const response = await api.get('/attendance/can-clock-in');
    return response.data;
  },

  async getMyAttendance(startDate?: string, endDate?: string): Promise<AttendanceRecord[]> {
    const queryString = buildQueryString({
      startDate,
      endDate,
    });

    const response = await api.get<AttendanceRecord[]>(`/attendance/my-attendance?${queryString}`);
    return response.data;
  },

  async getMySummary(year: number, month: number): Promise<AttendanceSummary> {
    const queryString = buildQueryString({ year, month });
    const response = await api.get<AttendanceSummary>(`/attendance/my-summary?${queryString}`);
    return response.data;
  },

  async getMyDeductions(year: number, month: number): Promise<AttendanceRecord[]> {
    const queryString = buildQueryString({ year, month });
    const response = await api.get<AttendanceRecord[]>(`/attendance/my-deductions?${queryString}`);
    return response.data;
  },

  async getMostPunctualStaff(year?: number, month?: number): Promise<{ name: string | null }> {
    const params: Record<string, string> = {};
    if (year) params.year = year.toString();
    if (month) params.month = month.toString();
    const queryString = buildQueryString(params);
    const response = await api.get<{ name: string | null }>(
      `/attendance/most-punctual?${queryString}`,
    );
    return response.data;
  },
};

export default attendanceService;
